import { updateBulletData } from '../utils';
import { runAxios } from '../../../handlers/axios';

/**
 *
 * @param e
 * @param stateProps
 * @param jobSeekerData
 */
export const handleDone = (e, stateProps, jobSeekerData) => {
  handleChange(e, stateProps, jobSeekerData);
  stateProps.onBulletClose();

};

export const handleResponse = (event, stateProps) => {
  stateProps.tempBullet = event.target.value;
};
/**
 *
 * @param event
 * @param stateProps
 * @param jobSeekerData
 */

export const handleChange = (event, stateProps, jobSeekerData) => {
  const moption = stateProps.bulletData.bulletModal;
  moption.buttonLabels = [jobSeekerData[stateProps.sectionData.sectionIndex][moption.qid]];
  if (moption.type !== 'recommended') {
    moption.qid = stateProps.tempBullet;
  }
  if(moption.type == 'recommended' && stateProps.bulletData.bulletGroup !== 'recommended') {
    moption.qid = stateProps.tempBullet;
  }
  //<shameless?>
  //if the user clicks done without focussing on the field then e.target.value is an array
  const tempBullet = Array.isArray(stateProps.tempBullet) ? stateProps.tempBullet[0] : stateProps.tempBullet;
  //</shameless?>
  if (stateProps.bulletData.bulletGroup !== 'recommended') {
    updateBulletData({
      bulletValue: { key: moption.key, value: tempBullet },
      //bulletModal: {},
    }, stateProps);
  }
};

export const handleRegenDirect = (props, bulletGroup, bulletIndex) => {
  const stateProps = props.stateProps;
  const origBullet = stateProps.bulletData.unselectedBullets[bulletGroup][bulletIndex];
  handleBulletRegen(props, origBullet);

};

const handleBulletRegenCallback = (result,args) => {
  const bulletValue = result.data;
  const stateProps = args.props.stateProps;

  const oldKey = args.oldKey;
  switch (stateProps.bulletData.bulletGroup) {
    case 'recommended':
      regenFillable(stateProps, bulletValue, 'recommended', oldKey);
      break;
    case 'fillable':
      regenFillable(stateProps, bulletValue, 'fillable', oldKey);
      break;
    case 'searched':
      regenFillable(stateProps, bulletValue, 'searched', oldKey);
      break;
    case 'freeform':
      regenFreeform(stateProps, bulletValue, 'freeform', oldKey);
      break;
    default:
      regenFillable(stateProps, bulletValue, 'generic', oldKey);

  }
  stateProps.setSpinnerImage('default.gif');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
}

/**
 *
 * @param props
 * @param origBulletRaw
 */
const handleBulletRegen = (props, origBulletRaw = null) => {
  const stateProps = props.stateProps;
  let origBullet = origBulletRaw.label;
  //why does this require == and not ===???
  if (stateProps.bulletData.bulletGroup == 'recommended') {
    origBullet = origBulletRaw.label.replace('~', origBulletRaw.buttonLabels[0]);
  }
  if (stateProps.bulletData.bulletGroup == 'fillable') {
    origBullet = origBulletRaw === null ? stateProps.tempBullet : origBulletRaw.label.replace('~', origBulletRaw.buttonLabels[0]);
  }
  if (stateProps.bulletData.bulletGroup == 'freeform') {
    origBullet = origBulletRaw.buttonLabels[0][0];
  }
  const moption = stateProps.bulletData.bulletModal;
  const oldKey = typeof moption.key !== 'undefined' ? moption.key : origBulletRaw.key;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  //change to professional experience title.
  const peIndex = stateProps.sectionData.sectionIndex;
  const jobTitle = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'][peIndex]['job_title'];
  const industry = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'][peIndex]['industry'];

  const target_industry = stateProps.dataToSave.saved.resumes[resumeIndex].industry[0];
  const target_job_title = stateProps.dataToSave.saved.resumes[resumeIndex]['job_title'];
  const url = stateProps.domain + '/wp-json/rsworks/v1/regenerate_bullet';
  const request = {
    'target_job_title':target_job_title,
    'target_industry': target_industry,
    'job_title': jobTitle,
    'industry': industry,
    'origBullet': origBullet };
  const args = {
    props:props,
    message:'Regenerating Bullet',
    oldKey: oldKey
  }
  stateProps.setSpinnerMessage('Crafting the perfect bullet.\n'  );
  stateProps.setSpinnerImage('bullets.gif');
  stateProps.onSpinnerOpen();

  runAxios(url,request,handleBulletRegenCallback,args);
};
const regenFreeform = (stateProps, bulletValue, type, oldKey) => {
  if(typeof stateProps.bulletData.unselectedBullets[type] !== 'undefined' ) {
    for (const bullet of stateProps.bulletData.unselectedBullets[type]) {
      if (bullet.key === oldKey) {
        stateProps.bulletData.bulletValue.value = bulletValue;
        bullet.buttonLabels[0] =bulletValue;
        bullet.label = bulletValue;
        bullet.qid = bulletValue;
        bullet.key = oldKey + '_r';
      }
    }
  }
  if(typeof stateProps.bulletData.selectedBullets[type] !== 'undefined' ) {
    for (const bullet of stateProps.bulletData.selectedBullets[type]) {
      if (bullet.key === oldKey) {
        stateProps.bulletData.bulletValue.value = bulletValue;
        bullet.buttonLabels[0] = bulletValue;
        bullet.label = bulletValue;
        bullet.qid = bulletValue;
      }
    }
  }

  if(typeof stateProps.bulletData.bullets[type] !== 'undefined' ) {
    for (const bullet of stateProps.bulletData.bullets[type]) {
      if (bullet.key === oldKey) {
        stateProps.bulletData.bulletValue.value = bulletValue;
        if(typeof bullet.buttonLabels === 'undefined') {
          bullet.buttonLabels = [bulletValue];
        } else {
          bullet.buttonLabels[0] = [bulletValue];
        }
        bullet.label = bulletValue;
        bullet.qid = bulletValue;
      }
    }
  }


  updateBulletData({
    bulletValue: { key: oldKey, value: bulletValue.value },
    bulletModal: {},
  }, stateProps);
};

const regenFillable = (stateProps, bulletValue, type, oldKey) => {
  const newBullets = JSON.parse(JSON.stringify(stateProps.bulletData.bullets));
  const newSelectedBullets = JSON.parse(JSON.stringify(stateProps.bulletData.selectedBullets));
  const str = JSON.stringify(stateProps.bulletData.unselectedBullets)
  const newUnselectedBullets = JSON.parse(str);
  const newBullet = {
    key: oldKey + '_r',
    label: bulletValue,
    origMatches: [],
    questions: [],
    type: type,
  };
  if (!replaceBullet(newSelectedBullets, newBullet, stateProps, oldKey)) {
    intercalBullet(newUnselectedBullets, newBullet, type, stateProps, oldKey);
  }
  updateBulletData({
    bullets: newBullets,
    selectedBullets: newSelectedBullets,
    unselectedBullets: newUnselectedBullets,
    bulletModal: {},
  }, stateProps);
};

const replaceBullet = (bulletsToCheck, newBullet, stateProps, oldKey) => {
  let replaced = false;
  for (const [bulletIndex, bullet] of bulletsToCheck.entries()) {
    if (bullet.key === oldKey) {
      bulletsToCheck[bulletIndex] = newBullet;
      replaced = true;
      break;
    }
  }
  return replaced;
};

const intercalBullet = (newBullets, newBullet, type, stateProps, oldKey) => {
  let counter = 0;
  const bulletsToCheck = type !== null ? newBullets[type] : newBullets;
  for (const bullet of bulletsToCheck) {
    if (bullet.key === oldKey) {
      break;
    }
    counter++;
  }
  bulletsToCheck.splice(counter, 0, newBullet);
};